import React, { useEffect } from 'react';
import DGTH_row_open from '../components/DGTH/DGTH_row_open';
import DGTH_pdc from '../components/DGTH/DGTH_pdc';
import DGTH_close_open from '../components/DGTH/DGTH_close_open';
import DGTH_mrp from '../components/DGTH/DGTH_mrp';
import DGTH_supplier_order from '../components/DGTH/DGTH_supplier_order';
import DGTH_supplier_ddt from '../components/DGTH/DGTH_supplier_ddt';
import DGTH_item_model_movement from '../components/DGTH/DGTH_item_model_movement';
import DGTH_supplier_invoices_received from '../components/DGTH/DGTH_supplier_invoices_received';
import { LoginManager } from '../../core/login-manager';



export default function DataGridTopHook({ entity, data, setData, searchObj, setSearchObj, refreshData }) {

    const userInfo = LoginManager.getUserInfo();

    useEffect(() => {
        if (entity === "gyv_stocks" || entity === "gyv_supplier_order_2") {
            var a = document.querySelector('.search-pro-input');
            a.focus()
        }
    }, []);


    if (entity !== null) {
        return (
            <>
                {entity === 'item_model_movement' && (
                    <DGTH_item_model_movement entity={entity} searchObj={searchObj} />
                )}
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'gyv_open_customer_rows': return (
                            <DGTH_row_open entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} />
                        );
                        case 'gyv_close_customer_rows': return (
                            <DGTH_close_open entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} />
                        );
                        case 'gyv_pdc': return (
                            <DGTH_pdc entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} />
                        );
                        case 'gyv_mrp_order_list': return (
                            <>
                                <DGTH_mrp entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} />
                            </>
                        );
                        case 'supplier_order': return (
                            userInfo && userInfo.level === 3
                                ? <></>
                                : <DGTH_supplier_order entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} />
                        );
                        case 'supplier_transport_document': return (
                            userInfo && userInfo.level === 3
                                ? <></>
                                : <DGTH_supplier_ddt entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} />
                        );
                        case 'supplier_invoices_received': return (
                            <DGTH_supplier_invoices_received entity={entity} data={data} setData={setData} searchObj={searchObj} setSearchObj={setSearchObj} refreshData={refreshData} />
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
}
